import React from "react";

export default function DashboardAdherentsHeader() {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="min-w-0">
          <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
            Administration
          </p>

          <h1 className="mt-1 text-2xl font-bold text-slate-900 sm:text-[30px] dark:text-white">
            Dashboard adhérents
          </h1>

          <p className="mt-2 max-w-4xl text-sm leading-6 text-slate-600 dark:text-slate-300">
            Vue d’ensemble des inscriptions, adhérents, enseignants,
            utilisateurs et indicateurs clés du club.
          </p>
        </div>
      </div>
    </div>
  );
}